import React, { Component } from 'react';

import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Elevation } from 'rmwc/Elevation';
import { LinearProgress } from 'rmwc/LinearProgress';
import { Snackbar } from 'rmwc/Snackbar';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class AdminRoadmapDisplay extends Component{

  constructor(props) {
    super(props)
    this.state = {
    	data:{
      	'roadmapName' : '',
        'roadmapId' : ''
      },
      inputData: {
          roadmapName: ''
      },
      modifyView: 'default',
      errorMsg: ''
    };
  }

  handleNameChange = (event) => {
    let inputData = Object.assign({}, this.state.inputData)
    inputData.roadmapName = event.target.value
    this.setState({inputData: inputData}) 
  }

  handleModifySave = (e) => {
    e.preventDefault()
    if (this.state.inputData.roadmapName == '') {
      return this.setState({errorMsg: 'Please enter the necessary details before editing a roadmap.'})
    }

    let data = {
      'roadmap':
      {
        'name' : this.state.inputData.roadmapName
      }
    }

    api.adminRoadmapUpdate(this.props.user.accessToken, data, this.props.roadmapId)
    .then((result) => {
      if(result.status == 'success'){
        let data = Object.assign({}, this.state.data)

        data.roadmapId = result.data.roadmap.id
        data.roadmapName = result.data.roadmap.name
        let modifyView = 'default'
        this.props.handleEditAction(e)
        this.setState({data: data, modifyView: modifyView})
      }
      else{
        this.setState({ errorMsg: 'Error in modifying the roadmap.' })
      }
    }).catch((err) => {
      this.setState({ errorMsg: 'Error in modifying the roadmap. Please contact Admin!' })
    })
  }

  handleModifyCancel = (e) => {
    let modifyView
    modifyView = 'default'
    this.setState({modifyView: modifyView, errorMsg: ''})
  }

  handleRoadmapEditView = (e) => {
    let modifyView
    modifyView = 'edit_view'
    let inputData = Object.assign({}, this.state.inputData)
    inputData.roadmapName = this.state.data.roadmapName
    this.setState({modifyView: modifyView, errorMsg: '', inputData: inputData})
  }

  handleView = (e) => (
    this.props.onHandleRmView(this.props.roadmapId, this.props.roadmapName)
  )

  componentDidMount() {
    let inputData = Object.assign({}, this.state.inputData)
    let data = Object.assign({}, this.state.data)
    inputData.roadmapName = this.props.roadmapName
    data.roadmapName = this.props.roadmapName
    this.setState({inputData: inputData, data: data})
  }

  render() {
    let roadmapToShow
    let handleRoadmapEditView = this.handleRoadmapEditView
    let handleModifyCancel = this.handleModifyCancel
    let handleModifySave = this.handleModifySave

    if (this.state.modifyView == 'default') {
      roadmapToShow = (
        <Grid className="opportunity-list-item">
          <GridCell span="8">
            {this.state.data.roadmapName}  
          </GridCell>
          <GridCell span="2">
            <button className="mdc-button" align = "right" aria-label="Favorite" onClick= {((e) => handleRoadmapEditView(e))}>
              Edit
            </button>
          </GridCell>
          <GridCell span="2">
            <button className="mdc-button" align = "right" aria-label="Favorite" onClick = {this.handleView}>
              View
            </button>
          </GridCell>
        </Grid>
      )
    }
    else if (this.state.modifyView == 'edit_view') {
      roadmapToShow = (
        <div>
          <Grid>
            <GridCell span="12">
                <TextField fullwidth label ="Name of the Roadmap"  autoComplete="off"  name="name" value = {this.state.inputData.roadmapName} onChange = {this.handleNameChange} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span = "4">
                <Button raised style={{ width: '100%' }} onClick= {((e) => handleModifySave(e))}>Save</Button>
            </GridCell>
            <GridCell span = "4">
                <Button raised style={{ width: '100%' }} onClick= {((e) => handleModifyCancel(e))}>Cancel</Button>
            </GridCell>
            <GridCell span = "12">
              <StatusMessage error_msg = {this.state.errorMsg} />
            </GridCell>
          </Grid>
        </div>
      )
    }

    return( 
      <Elevation z='4' style={{background:'white'}}>
        {roadmapToShow}
      </Elevation>
    )
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminRoadmapDisplay);



// WEBPACK FOOTER //
// ./src/views/admin/AdminRoadmapDisplay.jsx